import { useState } from "react";
import { Checkbox } from "@material-ui/core";
import ImageIcon from "@material-ui/icons/Image";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import shortenFileName from "../../../../../utils/commonFunctions/shortenFileName";

const File = ({ name }: { name: string }) => {
	return (
		<div className="file-icon" id="file-icon">
			<ImageIcon style={{ fontSize: "5rem", color: "#44b700" }} />
			<p>{shortenFileName(name, 4)}</p>
			{/* <PictureAsPdfIcon style={{ fontSize: "5rem", color: "#ffd0a1" }} /> */}
		</div>
	);
};

export default File;
